export default "https://cdn-static.gokick.com/assets/672a5c69b0b224f66a9a6ac0576938eca42c1cee/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";